module.exports = __webpack_public_path__ + "static/media/pay-3.10ae4a09.svg";